import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { REDUX_SLICE_KEYS } from 'common/constants';
import type { RootState } from 'store';

const initialState: { errorMessages: string[] } = {
  errorMessages: []
};

export const errorHandlerSlice = createSlice({
  name: REDUX_SLICE_KEYS.errorHandler,
  initialState,
  reducers: {
    setErrorMessages: (state, action: PayloadAction<string[]>) => {
      state.errorMessages.push(...action.payload);
    },
    dismissErrorMessage: state => {
      state.errorMessages.shift();
    },
    clearErrorMessages: state => {
      state.errorMessages = [];
    }
  }
});

export const { setErrorMessages, dismissErrorMessage, clearErrorMessages } =
  errorHandlerSlice.actions;

const selectSelf = (state: RootState) => state;

export const getErrorMessages = createSelector(
  selectSelf,
  ({ errorHandler }) => errorHandler.errorMessages
);

export default errorHandlerSlice.reducer;
